"use client";
import { useEffect, useRef } from "react";

import { useInstantSearch } from "@stadium/shared/src/components/instant-search";

import SearchBar from "@stadium/ui/src/components/form/SearchBar";

import style from "./main.module.scss";

const useTemplateSearchBox = () => {
  const { setTemplateSearchQuery, templateSearchQuery } = useInstantSearch();
  const searchBoxRef = useRef(null);

  useEffect(() => {
    searchBoxRef.current?.focus();
  }, []);

  const handleSearchQueryChange = ({ value }) => setTemplateSearchQuery(value);

  const renderSearchBar = ({ searchBlockClass, id = "search-bar", placeholder = "Search" }) => (
    <div className={searchBlockClass}>
      <SearchBar
        id={id}
        classes={style.bottomMargin}
        placeholder={placeholder}
        isSearchClearable={true}
        initialQuery={templateSearchQuery}
        name="search-templates"
        onChange={handleSearchQueryChange}
        className={style.inputHeight}
        iconClass={style.resetIcon}
        inputRegex=""
        ref={searchBoxRef}
      />
    </div>
  );

  return {
    renderSearchBox: ({ className, placeholder }) =>
      renderSearchBar({ searchBlockClass: className, placeholder }),
    searchedTerm: templateSearchQuery,
    setSearchedTerm: setTemplateSearchQuery,
  };
};

export default useTemplateSearchBox;
